// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cIwQgE5w36krNot2VEMw {
    width: 100%;
    height: 100vh;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: 24px;
    padding-top: 12px;
    gap: 6px;

}

.gujfgHFL9DWKIPEQiGZ4 {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.JemiFCJxf7Dmc_TGQNOg {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    justify-content: center;
    align-items: center;
}

.iUZGCQ7QlzZgpAoxlbz3 {
    background: rgba(var(--tertiary-bg), 0.4);
    cursor: pointer;
    border-radius: 4vw;
    padding-top: 4vw;
    padding-bottom: 4vw;
    border: none;
    box-shadow: none;

    display: flex;
    justify-content: center;
    align-items: center;

}

.iUZGCQ7QlzZgpAoxlbz3:active {
    background: rgba(117, 130, 146, 0.40);
}

.htfhB9ahoEuhrqzOeTr0 {
    cursor: pointer;
    font-size: 8vw;
    font-style: normal;
    font-weight: 590;
    line-height: 100%; 
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-primary));
}

._dOJHOqP_vB4iWpuO1CS {
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
}
._dOJHOqP_vB4iWpuO1CS > svg > path {
    fill: rgb(var(--placeholder-primary));
}

._dOJHOqP_vB4iWpuO1CS:active > svg > path {
    fill: rgba(117, 130, 146, 0.40);
}

.D58QF6_tsw6BdllGj07x {
    /* margin-bottom: 25%; */
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.ymUMSRmImJw0jfxJrbn5 {
    text-align: center;
    font-size: 8vw;
    font-style: normal;
    font-weight: 510;
    line-height: 100%;
    letter-spacing: -0.264px;
    columns: rgb(var(--placeholder-primary));
}

.Ve96IhqjplsiPTHeSerb {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 12px;
}

.Yekq4NXOHHv5qsJ3WLUw {
    width: 7vw;
    height: 7vw;
    border-radius: 50%;
    background: rgba(var(--placeholder-primary), 0.2);
    transition: background ease-in-out 0.5;
}

.VlCqeIrViZxQvazsQ55I {
    background: rgba(var(--placeholder-primary), 1);
}

.Az_me1hvDViroUcW8GaO {
    background: rgba(var(--accent-error), 1);
}

.r7HeTS0Ij__7Cn9GILMd {
    background: rgba(var(--accent-success), 1);
}`, "",{"version":3,"sources":["webpack://./src/components/pinpad/pinpad.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;;IAEhB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,oBAAoB;IACpB,iBAAiB;IACjB,QAAQ;;AAEZ;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;;IAEhB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;AAEvB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;AACnB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iDAAiD;IACjD,sCAAsC;AAC1C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;AAC9C","sourcesContent":[".container {\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding-bottom: 24px;\n    padding-top: 12px;\n    gap: 6px;\n\n}\n\n.secondTopWrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.pinPad {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n}\n\n.pinPadButton {\n    background: rgba(var(--tertiary-bg), 0.4);\n    cursor: pointer;\n    border-radius: 4vw;\n    padding-top: 4vw;\n    padding-bottom: 4vw;\n    border: none;\n    box-shadow: none;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n}\n\n.pinPadButton:active {\n    background: rgba(117, 130, 146, 0.40);\n}\n\n.numSymbol {\n    cursor: pointer;\n    font-size: 8vw;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 100%; \n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-primary));\n}\n\n.delete {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n}\n.delete > svg > path {\n    fill: rgb(var(--placeholder-primary));\n}\n\n.delete:active > svg > path {\n    fill: rgba(117, 130, 146, 0.40);\n}\n\n.topWrapper {\n    /* margin-bottom: 25%; */\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.topTitle {\n    text-align: center;\n    font-size: 8vw;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 100%;\n    letter-spacing: -0.264px;\n    columns: rgb(var(--placeholder-primary));\n}\n\n.pinDots {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 12px;\n}\n\n.pinDot {\n    width: 7vw;\n    height: 7vw;\n    border-radius: 50%;\n    background: rgba(var(--placeholder-primary), 0.2);\n    transition: background ease-in-out 0.5;\n}\n\n.filled {\n    background: rgba(var(--placeholder-primary), 1);\n}\n\n.failure {\n    background: rgba(var(--accent-error), 1);\n}\n\n.success {\n    background: rgba(var(--accent-success), 1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cIwQgE5w36krNot2VEMw`,
	"secondTopWrapper": `gujfgHFL9DWKIPEQiGZ4`,
	"pinPad": `JemiFCJxf7Dmc_TGQNOg`,
	"pinPadButton": `iUZGCQ7QlzZgpAoxlbz3`,
	"numSymbol": `htfhB9ahoEuhrqzOeTr0`,
	"delete": `_dOJHOqP_vB4iWpuO1CS`,
	"topWrapper": `D58QF6_tsw6BdllGj07x`,
	"topTitle": `ymUMSRmImJw0jfxJrbn5`,
	"pinDots": `Ve96IhqjplsiPTHeSerb`,
	"pinDot": `Yekq4NXOHHv5qsJ3WLUw`,
	"filled": `VlCqeIrViZxQvazsQ55I`,
	"failure": `Az_me1hvDViroUcW8GaO`,
	"success": `r7HeTS0Ij__7Cn9GILMd`
};
export default ___CSS_LOADER_EXPORT___;
